<div class="wrapper-snackbar">
  <div class="data" [attr.aria-label]="data?.message">
    <mat-icon class="message-icon" *ngIf="data?.iconLeft" aria-hidden="false" aria-description="Ícone da mensagem">
      {{ data?.iconLeft }}
    </mat-icon>
    {{ data?.message }}
  </div>
  <div class="dismiss" *ngIf="data?.buttonText || data.buttonText">
    <button
      class="button-text"
      *ngIf="data?.buttonText && !data.closeIcon"
      mat-stroked-button
      (click)="snackBarRef.dismiss()"
      aria-label="Fechar mensagem">
      {{ data.buttonText }}
    </button>
    <button *ngIf="data.closeIcon" mat-icon-button (click)="snackBarRef.dismiss()" aria-label="Fechar mensagem">
      <mat-icon> close </mat-icon>
    </button>
  </div>
</div>
